module.exports = __webpack_public_path__ + "img/skip-button.b946153a.png";